module.exports = __webpack_public_path__ + "static/media/welcome-audio.ecc696fd.mp3";